import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGiftBox: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconGiftBox"><Path d="M2 6.75C2 5.23122 3.23122 4 4.75 4H11.25V9H3.75C2.7835 9 2 8.2165 2 7.25V6.75Z" fill="currentColor"/><Path d="M3 10.5H11.25V20H5.75C4.23122 20 3 18.7688 3 17.25V10.5Z" fill="currentColor"/><Path d="M12.75 4H19.25C20.7688 4 22 5.23122 22 6.75V7.25C22 8.2165 21.2165 9 20.25 9H12.75V4Z" fill="currentColor"/><Path d="M12.75 10.5H21V17.25C21 18.7688 19.7688 20 18.25 20H12.75V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGiftBox;
